<script setup>
defineProps({
    name: {
        type: String,
        required: true,
    },
    id: {
        type: [String, Number],
        default: null,
    },
    tooltip: {
        type: String,
        default: 'Detalhes',
    },
    icon: {
        type: String,
        default: 'pi pi-external-link',
    },
    // Para rotas com parâmetros além de `id` (ex.: { aplicacaoId, projetoId }); quando informado, substitui o `id`
    params: {
        type: Object,
        default: null,
    },
});

</script>

<template>
    <span>
        <RouterLink :to="{ name: name, params: params ?? (id ? { id: Number(id) } : {}) }">
            <Button :icon="icon" text size="small" severity="secondary"
                v-tooltip.bottom="{ value: tooltip }" />
        </RouterLink>
    </span>
</template>